import { ISpinnerProps } from './Spinner.model';
import { StyledSpinnerSpan, StyledSpinnerContainer } from './Spinner.styled';

const Spinner = ({ color, ...props }: ISpinnerProps) => {
	return (
		<StyledSpinnerContainer {...props}>
			<StyledSpinnerSpan color={color} />
		</StyledSpinnerContainer>
	);
};

export { Spinner };
